/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingConfiguration } from '../../models/charging-configuration';

export interface ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Params {
  chargerId: string;
  connectorId: number;
}

export function apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json(http: HttpClient, rootUrl: string, params: ApiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
  const rb = new RequestBuilder(rootUrl, apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('chargerId', params.chargerId, {});
    rb.path('connectorId', params.connectorId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargingConfiguration>;
    })
  );
}

apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json.PATH = '/api/ChargingConfiguration/GetByChargerIdAndConnectorId/{chargerId}/{connectorId}';
